<template>
    <div>
        <form @submit.prevent="subscribe" class="row g-1 mb-2">
            <div class="col-auto">
                <input v-model="emailAddress" type="email" placeholder="enter email" class="form-control" required />
            </div>
            <div class="col-auto">
                <button type="submit" class="btn btn-primary">Sign up</button>
            </div>
        </form>
        <a @click.prevent="hideForever" class="font-xs">Hide forever</a>
        <p class="signup-message" v-if="success">Thanks for signing up!</p>
    </div>
        
</template>

<script>
    export default {
        props: {
            location: String,
            list_id: String
        },

        data() {
            return {
                emailAddress: null,
                success: null
            }
        },

        mounted() {
            
        },

        methods: {
            subscribe() {
                var self = this
                window.getRecaptchaToken()
                    .then(function(r) {
                        var data = {
                            email: self.emailAddress,
                            list_id: self.list_id,
                            recaptcha: r
                        }
                        axios.post('/system/subscribe', data)
                            .then(response=> {
                                self.success = true;
                                self.emailAddress = null
                                if("ga" in window) {
                                    var tracker = ga.getAll()[0];

                                    tracker.send('event', 'lead-Subscription', 'Submit', self.location) 
                                }
                                if("fbq" in window) {
                                    window.fbq('trackCustom', 'Subscribe', {venue: self.location});
                                }
                            })
                    })
            },
            hideForever() {
                window.Cookies.set("signupCookie",1,'90d');
                $('#signup-sideout').addClass('sideout-hide')
            },
            close() {
                $('#signup-sideout').addClass('sideout-hide')
            }
        }
    }
</script>
